import { render, staticRenderFns } from "./LoadableComponent.vue?vue&type=template&id=1fa72240&"
import script from "./LoadableComponent.vue?vue&type=script&lang=js&"
export * from "./LoadableComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoadableComponent.vue?vue&type=style&index=0&id=1fa72240&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports